import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import config from "config";
import { CustomerConfig } from "../../../src/Dashboard/actions/apiActions";
import { emptyEditViewState, updateCustomersList } from "../../ducks/customersDuck";
import { useDispatch } from "react-redux";
import { useCustomersList } from "../../hooks/useCloudSelectors";

const DeleteModal = ({ siteName, deviceId, toggleDeleteModal, type }) => {

  const allCustomers = useCustomersList();
  const dispatch = useDispatch();

  const deleteCustomerHandler = async () => {
    if (type === "customer") {
      const updatedCustomersObject = {
        customers: allCustomers.filter(customer => customer.customerName !== siteName)
      }

      const response = await CustomerConfig.post(config.CONFIGURATION_URL, updatedCustomersObject);
      dispatch(emptyEditViewState())
      dispatch(updateCustomersList(response.customers))
    } else if (type === "device") {

      const updatedCustomersObject = {
        customers: allCustomers.map(customer => customer.customerName === siteName ? {
          ...customer,
          devices: customer.devices.filter(device => device.deviceId !== deviceId)
        } : customer)
      }

      const response = await CustomerConfig.post(config.CONFIGURATION_URL, updatedCustomersObject);
      dispatch(updateCustomersList(response.customers));
    }
  }
  return (
    <Dialog open onClose={toggleDeleteModal}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete?</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={toggleDeleteModal}>Close</Button>
        <Button variant="contained" color="error" onClick={deleteCustomerHandler}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
